__turbopack_context__.v({
  "content": "legalText-module-scss-module__qLkMVa__content",
  "darkBlue": "legalText-module-scss-module__qLkMVa__darkBlue",
  "header": "legalText-module-scss-module__qLkMVa__header",
  "legalText": "legalText-module-scss-module__qLkMVa__legalText",
});
